import { AppLink } from '@/shared/lib/router'

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Jornadas', href: '#jornadas' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Gamificação', href: '#ranking' }
]

export function LandingFooter() {
  return (
    <footer className="bg-brand-dark text-white/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {/* Brand */}
          <div className="col-span-full lg:col-span-1">
            <div className="flex items-center gap-2">
              <img
                src="/brand/logo-horizontal-white.svg"
                alt="Missão Futuro"
                width={109}
                height={28}
                loading="lazy"
                decoding="async"
                className="h-7 w-auto"
              />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed">
              Plataforma Gamificada de Educação Empreendedora — transformando
              jovens em protagonistas do futuro.
            </p>
          </div>

          {/* Nav */}
          <nav aria-label="Rodapé">
            <div className="mb-4 text-xs font-bold uppercase tracking-widest text-white/40">
              Navegação
            </div>
            <ul className="space-y-3 text-sm">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="transition hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Institutional logo — placeholder asset from tmp/, swap for the
              official Sebrae-provided file when available (see NOTES). */}
          <div>
            <div className="mb-4 text-xs font-bold uppercase tracking-widest text-white/40">
              Realização
            </div>
            <div className="flex h-16 items-center">
              <img
                src="/brand/sebrae-educacao-empreendedora-white.png"
                alt="Sebrae — Educação Empreendedora"
                width={288}
                height={69}
                loading="lazy"
                decoding="async"
                className="h-16 w-auto"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs">
            © {new Date().getFullYear()} Educação Empreendedora | Sebrae. Todos os direitos reservados.
          </p>
          <div className="flex gap-6 text-xs">
            <AppLink
              href="/politica-de-privacidade"
              className="transition hover:text-white"
            >
              Privacidade
            </AppLink>
            <AppLink
              href="/termos-de-uso"
              className="transition hover:text-white"
            >
              Termos de uso
            </AppLink>
          </div>
        </div>
      </div>
    </footer>
  )
}
